import * as R from 'ramda'
import tap from 'tap-logger'
import {conekta} from '../mixins/conekta'
import Pair from 'crocks/Pair'
import {numberFilters} from '../mixins/number-filters'
import {prefillCheckoutData} from '../helpers/testing-helpers'
import StickerMessagePreview from '../components/sticker-message-preview.vue'

const {parseMoney}  = numberFilters.filters
const processStamps = labels => R.pipe(
	R.chain(label =>
		R.map(stamp =>
				({
				font: R.pathOr({}, ['font'], label),
				container: R.pathOr({}, ['template', 'container'], label),
				stamp
				}),
			label.template.stamps
		)
	)
)(labels)
// validator :: {key: 'err_msg'} -> {key: val || undefined} -> ['err_msg']
const validate = (spec, obj) =>
  R.pipe(
    R.mapObjIndexed((msg, key) =>
        obj[key] === ''
        || obj[key] === undefined
           ? msg
           : undefined
   ),
    R.pickBy(v => v !== undefined),
    R.values
  )(spec)

const makeSpec = (keys, copies) => R.pipe(
	R.map(key => ({ [key] : copies[key] || `Hubo un error en el campo ${key}` })),
	R.mergeAll,
)(keys)

const formatMoney = R.pipe(amount => amount/100, parseMoney)

// Mexico country id.
const COUNTRY_MEXICO = 1;

export const checkout = {
	el: '#checkout-vue',
	components: {
		StickerMessagePreview
	},
	mixins: [conekta],
	ready() {
		if(process.env.NODE_ENV !== 'prod') {
			window.prefillCheckoutData = () => prefillCheckoutData(this.$data)
		}
	},
	data: {
		checkout_form: 'checkout_form',
		first_name: '',
		last_name: '',
		country: '',
		state: '',
		street_1: '',
		street_2: '',
		street_3: '',
		city: '',
		zip_code: '',
		phone: '',
		email: '',
		email_confirmation: '',
		references: '',
		//payment_method
		payment_method: '',
		//card
		credit_card: {
			number: '',
			name: '',
			exp_month: '',
			exp_year: '',
			cvc: '',
		},
		previewedSticker: {},
		previewCache: {},
		fonts: [],
		//spei
		spei: false,
		//paypal
		paypal: false,
		//Discount Code
		discount_code: '',
		//terms accepted
		terms_accepted: false,
        //address
		selectedAddress: null,//Null | Int | 'new_address'
		selectedCard: null,//Null | Int | 'new_card'
		// selectedAddress: '',//Null | Int | 'new_address'
		// selectedCard: ''//Null | Int | 'new_card'
		serverValidated: null, //Variable que valida el request en el server
		btn_submit_checkout: 'checkout__make',
		helper_states: [],
		helper_cities: [],
		helper_complete: []

	},

	watch: {
		payment_method() {
			if(this.payment_method !== 'conekta_card') {
				this.selectedCard = null
			}else if(this.userCards.length === 0){
				this.selectedCard = 'new_card'
			}
		},
		userAddresses: {
			immediate: true,
			handler() {
				if(this.userAddresses.length === 0) {
					this.selectedAddress = 'new_address'
				}
			}
		},
        userCards: {
			immediate: true,
			handler() {
				if(this.userCards.length === 0) {
					this.selectedCard = 'new_card'
				}
			}
		},
		previewData() {
			this.fonts = R.pipe(
				R.pathOr([], ['stamps']),
				R.map(R.path(['font', 'google_url'])),
				R.reject(R.isNil),
				R.concat(this.fonts),
				R.uniq,
			)(this.previewData)

			this.$broadcast('resize-font')
		},
	},

	computed: {
		copies() {
			return this.$root.store.copies.checkout
		},

		items() {
            var items =  R.pipe(
				R.pathOr([], ['store', 'cart', 'data', 'items'])
			)(this);
			items.forEach(function(item){
				var texts= "";
				item.customizations.texts.forEach(function(text){
 				   texts+=text+"\n";
 			   });
               item.completeText = texts
			});
			return items;
		},

        minToFreeShipping() {
            return R.pathOr(Infinity, ['store', 'min_to_free_shipping'], this);
        },

        subtotal() {
			return R.pathOr(0,
				['store', 'cart', 'data', 'subtotal'],
				this
			)
		},

        isFreeShipping() {
            return this.subtotal > this.minToFreeShipping;
        },

        discount() {
			return R.pathOr(0, ['store', 'discount', 'value'], this)
		},

        shippingCost() {
			return R.pathOr(9900, ['store', 'shipping_cost'], this);
		},

		total() {
            let shippingCost = this.shippingCost;

            if (this.isFreeShipping) {
                shippingCost = 0;
            }

            return this.subtotal + shippingCost + this.discount;
		},

		userAddresses() {
			return R.pipe(
				R.pathOr([], ['store', 'current_user', 'addresses']),
				R.map(a => ({
					id: a.id,
					name: a.label
				}))
			)(this)
		},

		userCards() {
			return R.pipe(
				R.pathOr([], ['store', 'current_user', 'cards']),
				R.map(c => ({
					id: c.token,
					digits: c.label
				}))
			)(this)
        },

		states() {
			return R.pipe(
				R.pathOr([], ['store', 'mexico_states_and_mun']),
				R.keys
			)(this)
		},

		municipalities() {
			return R.pipe(
				R.pathOr([], ['store', 'mexico_states_and_mun']),
				R.pathOr([], [this.state]),
				R.map(R.prop('NOM_MUN'))
			)(this)
		},

        countries(){
			return R.pipe(
				R.pathOr([], ['store', 'countries']),
			)(this)
        },

		previewData() {
			return R.pipe(
				R.pick(['customizations', 'labels']),
				({customizations, labels}) => ({
					texts: R.pathOr([], ['texts'], customizations),
					stamps: processStamps(labels || {}),
				}),
			)(this.previewedSticker)
		},

        isMexicoAddress() {
            return this.country === COUNTRY_MEXICO;
        }
	},

	methods: {
		isEmpty: R.isEmpty,
		formatMoney,

        changeStates(event) {
            let url = R.replace(
                '__country__',
                event.target.value,
                this.$root.store.routes.countries.get
            )

            this.$http.get(url)
                .then(({body}) => {
                    this.helper_states = this.filterStates(body);
                    this.helper_complete = body;
                })
                .catch(this.$root.ajaxErrAlerting)
        },

        filterStates(arr) {
            return R.pipe(R.keys)(arr);
        },

		changeCities( event ){

			let state = event.target.value;
			let cities =  R.pipe(
				R.pathOr([], [ state ]),
				R.map(R.prop('NOM_MUN'))
			)( this.helper_complete );

			this.helper_cities = R.uniq( cities );
		},

		postDiscountCode() {
			if(this.discount_code === '') {
				this.alertError([this.copies.errors.discount_required])
				return
			}
			let url = R.replace(
				'__discount-code__',
				this.discount_code,
				this.$root.store.routes.discounts.post
			)

			this.$http.get(url, {
				 params: {subtotal: this.subtotal}
			})
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.$root.alert(body)
					this.$root.store.discount = body.data
				})
				.catch(this.$root.ajaxErrAlerting)
		},

		makePost(event) {
			let button = document.getElementById(this.btn_submit_checkout);
			let text = button.textContent;

			let errors = [].concat(
				this.validateAddress(this.$data),
				this.validatePayment(this.credit_card),
				this.validateTerms(this.$data),
			)

			if(errors.length > 0) {
				this.alertError(errors)
				button.disabled = false;
				button.textContent = text;
				return;
			}

			if(this.serverValidated != null){
				button.disabled = true;
				button.textContent = "Procesando...";
			}

			if (this.payment_method === 'conekta_card' && this.selectedCard === 'new_card') {
				this.conektaPost(this.credit_card)
			}else {
				this.postCheckout()
			}
		},

		postCheckout() {
			//Post es una función creada en el archivo crud-ajax.js
			this.post(document.getElementById(this.checkout_form));
		},

		//Tanto esta función como la que sigue, se llaman dinámicamente en el archivo crud-ajax.js
		onCheckoutError(body){
			let button = document.getElementById(this.btn_submit_checkout);

			button.disabled = false;
			button.textContent = "Realizar el pedido";
		},

		onCheckoutSuccess(body) {
			window.location = body.data.redirect_url
		},

        validateShippingAddress() {
			let url = this.$root.store.routes.shipping.validate;
			let missingFields = this.validateAddress().length !== 0;

            if (missingFields) { return; }

			this.$http.post(url, {
				_token: this.store.csrf_token,
				other_shipment: this.selectedAddress === 'new_address' ? 1 : 0,
				shipment_id: this.selectedAddress,
				shipment: {
					first_name: this.first_name,
					last_name: this.last_name,
					phone: this.phone,
					email: this.email,
					email_confirmation: this.email_confirmation,
					country_id: this.country,
					state: this.state,
					street_1: this.street_1,
					street_2: this.street_2,
					street_3: this.street_3,
					city: this.city,
					zip_code: this.zip_code,
					references: this.references,
				}
			})
				.then(() => {
					this.serverValidated = true;
				})
				.catch(this.$root.ajaxErrAlerting);
		},

		validateAddress() {
			if(this.selectedAddress === null) {//no se ha seleccionado nada
				return [this.copies.errors.empty_address]
			}

			if(this.selectedAddress === 'new_address') {
                // se ha seleccionado new_address
                let spec = [
                    'first_name',
                    'last_name',
                    'email',
                    'email_confirmation',
                    'phone',
                    'country',
                    'state',
                    'street_1',
                    'city',
                    'zip_code',
                ];

                if (this.isMexicoAddress) {
                    // if is a mexico address
                    // street_2 (municipio) and street_3 (colonia)
                    // are required.
                    spec.push('street_2', 'street_3');
                }

                return validate(
                    makeSpec(spec, this.copies.errors),
                    this.$data
                );
			}

            // se ha seleccionado un id
            return [];
		},

		validatePayment($data) {
			if(this.payment_method === '') {
				return [this.copies.errors.payment_method]
			}

			if(this.payment_method === 'conekta_card' && this.selectedCard === null) {
				return [this.copies.errors.empty_card]
			}

			if(this.payment_method === 'conekta_card' && this.selectedCard === 'new_card') {
				let spec = makeSpec([
					'number',
					'name',
					'exp_month',
					'exp_year',
					'cvc',
				], this.copies.errors)

				return validate(spec, $data)
			}

			return []
		},

		validateTerms() {
			if(this.terms_accepted === false) {
				return [this.copies.errors.terms_accepted]
			}
			return []
		},
		getStickerPreview(item_id) {
			let url = R.pipe(
				R.replace('__item_id__', item_id),
			)(this.$root.store.routes.stickerPreview.get)

			if(this.previewCache[item_id]) {//para no hacer un get cada vez que se vea el mismo sticker
				this.previewedSticker = this.previewCache[item_id]
				return
			}
			console.log("lalala:");
            console.log(url);
			this.$http.get(url)
				//TODO
				.then(tap.c('getStickerPreview'))
				.then(R.path(['body']))
				.then(data => {
					this.previewCache[item_id] = data
					this.previewedSticker = this.previewCache[item_id]
					//console.log(this.previewedSticker);
					return data
				})
				.catch(err => {

					this.alertError([err.statusText])
					this.previewedSticker = {something: 'blaaa'}
				})
		},
		closeStickerPreview() {
			this.previewedSticker = {}
		},

		trimOnBlur(){
			this.email = this.email.trim();
			this.email_confirmation = this.email_confirmation.trim();
		}
	},

};



// WEBPACK FOOTER //
// ./resources/assets/js/vue/main/checkout.js